import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import cn from 'classnames';
import { PureComponent } from 'react';
import PopoverWrapper, { APPEARANCE_DURATION, POSITION, POSITIONS } from '@mos-cat/popover-wrapper';
import THEMES from './inner/themes';
import './styles/ConfirmationPopover.scss';
/**
 * @class
 */
var ConfirmationPopover = /** @class */ (function (_super) {
    __extends(ConfirmationPopover, _super);
    function ConfirmationPopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.popover = React.createRef();
        _this.handlePopoverClose = function (event) {
            var _a = _this.props, isPopoverOpen = _a.isPopoverOpen, onPopoverClose = _a.onPopoverClose;
            if (!event.defaultPrevented && isPopoverOpen) {
                onPopoverClose(event);
            }
        };
        _this.handleConfirm = function (event) {
            var onConfirm = _this.props.onConfirm;
            if (onConfirm) {
                onConfirm(event);
            }
            if (event.defaultPrevented) {
                return;
            }
            _this.handlePopoverClose(event);
        };
        _this.handleCancel = function (event) {
            var onCancel = _this.props.onCancel;
            if (onCancel) {
                onCancel(event);
            }
            if (event.defaultPrevented) {
                return;
            }
            _this.handlePopoverClose(event);
        };
        return _this;
    }
    ConfirmationPopover.prototype.render = function () {
        var _a = this.props, theme = _a.theme, className = _a.className, wrapperClassName = _a.wrapperClassName, children = _a.children, isPopoverOpen = _a.isPopoverOpen, position = _a.position, title = _a.title, description = _a.description, acceptText = _a.acceptText, cancelText = _a.cancelText, icon = _a.icon, otherProps = __rest(_a, ["theme", "className", "wrapperClassName", "children", "isPopoverOpen", "position", "title", "description", "acceptText", "cancelText", "icon"]);
        var contentClassNames = cn('Confirmation__popover', "Confirmation__popover_" + theme, "Confirmation__popover_" + position, "Block_" + theme, "Block_" + theme + "_bordered", className);
        var wrapperClassNames = cn('Confirmation__wrapper', "Confirmation__wrapper_" + theme, "Confirmation__wrapper_" + theme + "_bordered", wrapperClassName);
        return (React.createElement(PopoverWrapper, __assign({ open: isPopoverOpen, position: position, className: wrapperClassNames }, otherProps, { content: React.createElement("div", { className: "Confirmation__container" },
                React.createElement("div", { className: contentClassNames, ref: this.popover },
                    icon && React.createElement("div", { className: "Confirmation__icon" }, icon),
                    React.createElement("h3", { className: "Confirmation__title" }, title),
                    description && (React.createElement("p", { className: "Confirmation__description" }, description)),
                    React.createElement("div", { className: "Confirmation__buttons" },
                        React.createElement("button", { className: "Confirmation__button Confirmation__button_accept", type: "button", onClick: this.handleConfirm }, acceptText),
                        React.createElement("button", { className: "Confirmation__button Confirmation__button_cancel", type: "button", onClick: this.handleCancel }, cancelText)))) }), React.Children.only(children)));
    };
    ConfirmationPopover.defaultProps = {
        className: '',
        wrapperClassName: '',
        theme: THEMES.ATTENTION,
        position: POSITION.top,
        modal: false,
        icon: null,
        description: '',
        acceptText: 'Подтвердить',
        cancelText: 'Отменить',
        isPopoverOpen: false,
        floating: false,
        considerHeader: false,
        trackChildPosition: true,
        onPopoverClose: function () { }
    };
    return ConfirmationPopover;
}(PureComponent));
export { ConfirmationPopover as default, THEMES, POSITION, POSITIONS, APPEARANCE_DURATION };
//# sourceMappingURL=ConfirmationPopover.js.map